import * as React from 'react'
import { useQueryVehiclesList } from '@/lib/api/company/vehicle-list/useQueryVehiclesList'

// Registration number per vehicle id, inactive vehicles included (a saved chart may point at one).
export function useVehicleLabels(companyId: string): Map<number, string> {
  const q = useQueryVehiclesList({ companyId, search: '', pageSize: 1000 })
  return React.useMemo(() => {
    const list = (q.data as any) || []
    const vehicles: any[] = Array.isArray(list) ? list : list.vehicles || []
    return new Map(
      vehicles.map((v) => [
        v.id as number,
        (v.registrationNumber || v.registrationNumberFromTachograph || `#${v.id}`) as string,
      ]),
    )
  }, [q.data])
}
